import React from 'react';

import styles from '../styles/HomeBannerTextV2.module.scss';

interface HomeBannerTextCmpV2Props {
  title: string;
  description: string;
}

function HomeBannerTextCmpV2({
  title,
  description,
}: HomeBannerTextCmpV2Props): React.ReactElement {
  return (
    <div className={styles['banner-wrapper']}>
      <h1 className={styles['banner-subtext']}>{description}</h1>
      <h1 className={styles['banner-text']}>{title}</h1>
    </div>
  );
}

export default HomeBannerTextCmpV2;
